var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {},
    [
      _c(
        "v-toolbar",
        { staticClass: "primary darken" },
        [
          _c("v-toolbar-title", { staticClass: "white--text" }, [
            _vm._v("This Month")
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-container",
        { attrs: { "grid-list-md": "" } },
        [
          _c(
            "v-layout",
            { attrs: { row: "", wrap: "" } },
            [
              _c(
                "v-flex",
                { attrs: { sm12: "", md6: "" } },
                [
                  _vm.birthdaysThisMonth === null
                    ? _c(
                        "v-container",
                        [
                          _c("v-progress-circular", {
                            attrs: { color: "primary", indeterminate: "" }
                          })
                        ],
                        1
                      )
                    : _c(
                        "v-card",
                        { staticClass: " " },
                        [
                          _c(
                            "v-card-title",
                            { staticClass: "primary darken white--text" },
                            [
                              _vm._v(
                                "\n                    Birthdays\n                    "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("v-data-table", {
                            attrs: {
                              light: "",
                              headers: _vm.headersBirthday,
                              items: _vm.birthdaysThisMonth,
                              "hide-default-footer": ""
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "items",
                                fn: function(props) {
                                  return [
                                    _c("tr", [
                                      _c("td", [
                                        _vm._v(_vm._s(props.item.name))
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(_vm._s(props.item.birthDate))
                                      ])
                                    ])
                                  ]
                                }
                              }
                            ])
                          })
                        ],
                        1
                      )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { sm12: "", md6: "" } },
                [
                  _vm.anniversariesThisMonth === null
                    ? _c(
                        "v-container",
                        [
                          _c("v-progress-circular", {
                            attrs: { color: "primary", indeterminate: "" }
                          })
                        ],
                        1
                      )
                    : _c(
                        "v-card",
                        {},
                        [
                          _c(
                            "v-card-title",
                            {
                              staticClass:
                                "tile-contacts primary darken white--text"
                            },
                            [
                              _vm._v(
                                "\n                    Anniversaries\n                    "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("v-data-table", {
                            attrs: {
                              light: "",
                              headers: _vm.headersAnniversaries,
                              items: _vm.anniversariesThisMonth,
                              "hide-default-footer": ""
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "items",
                                fn: function(props) {
                                  return [
                                    _c("tr", [
                                      _c("td", [
                                        _vm._v(_vm._s(props.item.name))
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(_vm._s(props.item.years))
                                      ])
                                    ])
                                  ]
                                }
                              }
                            ])
                          })
                        ],
                        1
                      )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-540d8e12", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-540d8e12","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/People/ThisMonth.vue
// module id = 5RCi
// module chunks = 1